{
  "tabs": {
    "overview": "Overview",
    "subaccount": "Sub-accounts",
    "affiliates": "Affiliates",
    "transfers": "Transfers",
    "ledger": "Ledger",
    "documents": "Documents",
    "trades": "Trades"
  },
  "accountStates": "Account States",
  "linkedSubAccount_one": "1 sub-account linked",
  "linkedSubAccount_other": "{{count}} sub-accounts linked",
  "percentageOfTotalAssets": "{{percentage}} of total assets",
  "riskReturnLevel": "Risk and return level of {{count}}",
  "autoTransferEnabled_one": "Auto-transfer enabled on 1 portfolio",
  "autoTransferEnabled_other": "Auto-transfer enabled on {{count}} portfolios",
  "editAccount": "Edit Account",
  "noSections": "Nothing else to update",
  "state": "State",
  "custodianName": "Custodian Name",
  "dealerCode": "Dealer Code",
  "dealerName": "Dealer Name",
  "dealerAccountNumber": "Dealer Account Number",
  "accountState": {
    "ACTIVE": "Active",
    "CLOSED": "Closed",
    "PENDING": "Pending",
    "CANCELED": "Canceled",
    "FAILED": "Failed",
    "FROZEN": "Frozen",
    "INACTIVE": "Closed",
    "INITIATED": "Initiated",
    "READY": "Ready",
    "REQUESTED": "Requested"
  },
  "noAffiliates": "You currently have no information to display",
  "custodianAccountNumber": "Custodian ID",
  "none": "none",
  "feePaymentAccount": "Fee payment account",
  "tlh": "Tax loss harvesting",
  "tlhOptions": {
    "true": "Enabled",
    "false": "Disabled"
  },
  "feeGrid": "Fee grid",
  "billingCycle": "Billing cycle",
  "grant_one": "Grant",
  "grant_other": "Grants",
  "govGrants": "Government grants",
  "govFundOptions": {
    "ADDITIONAL_CESG": "Additional CESG",
    "BASIC_CESG": "Basic Canada Education Savings Grant",
    "CLB": "Canada Learning Bond",
    "QESI": "Québec Education Savings Incentive",
    "BCTESG": "British Columbia Training and Education Savings Grant",
    "CDSGB": "Canada Disability Savings Grant/Bond"
  },
  "eligibleForDTC": "Eligible for Disability Tax Credit?",
  "closeAccount": {
    "title": "Are you sure"
  },
  "closeAccountConfirmationDialog": {
    "title": "Cannot close account",
    "subtitle": "You need to close all sub-accounts and cancel any scheduled deposits before proceeding",
    "continueButton": "Ok, Got it"
  },
  "closeAccountDialog": {
    "title": "Are you sure?",
    "subtitle": "Closing this account will also close it with the custodian. If you would like to use this account in the future you will need to open a new account with the custodian.",
    "continueButton": "Yes - I’m sure",
    "cancelButton": "Cancel",
    "success": "Account has been closed successfully"
  },
  "associateAccountDialog": {
    "title": "Associate this account to {{name}} household?",
    "checkingSubaccounts": "Checking sub-accounts",
    "thereAreSubAccounts": "All attached goals and sub-accounts will also be moved to the household. This includes:",
    "thereAreNoSubAccounts": "Are you sure you want to move this account to the household?",
    "continueButton": "Yes - I’m sure",
    "cancelButton": "Cancel",
    "success": "Account has been associated to household."
  },
  "dissociateAccountDialog": {
    "title": "Dissociate this account from {{name}} household?",
    "checkingSubaccounts": "Checking sub-accounts",
    "continueButton": "Yes - I’m sure",
    "cancelButton": "Cancel",
    "checkingAccountGroups": "Checking account groups",
    "thereAreSubAccounts": "All attached goals and sub-accounts will also be removed from the household. This includes:",
    "thereAreNoSubAccounts": "Are you sure you want to remove this account from the household?",
    "thereAreBlockedSubAccounts": "There are sub-accounts linked to goals associated with other accounts. Please dissociate the goal instead. This includes:",
    "thereAreBlockedSubAccountsFootnote": "* Goal is associated with other accounts.",
    "thereAreBlockedAccountGroups": "This account belongs to a household account group. Please remove the account from the following group:",
    "success": "Account has been dissociated from household."
  },
  "jurisdiction": {
    "AB": "Alberta",
    "BC": "British Columbia",
    "FEDERAL": "Federal",
    "MB": "Manitoba",
    "NB": "New Brunswick",
    "NL": "Newfoundland and Labrador",
    "NS": "Nova Scotia",
    "ON": "Ontario",
    "PE": "Prince Edward Island",
    "QC": "Quebec",
    "SK": "Saskatchewan"
  },
  "jurisdictionTitle": "Jurisdiction",
  "accountDescriptions": {
    "RRSP": "A tax-sheltered account that allows for tax-deductible contributions. Contribution limits apply, and withdrawals may be taxed.",
    "TFSA": "A tax-sheltered account that allows for tax-free withdrawals. Annual contribution limits apply.",
    "PERSONAL": "A taxable, general investment account for an individual.",
    "RESP": "RESP",
    "FHSA": "A tax-sheltered account that allows a first-time home buyer to save up to $40k tax-free for a qualifying first home. Contribution limits apply.",
    "RESP_SINGLE": "A tax-sheltered account for a single beneficiary for post-secondary education savings. Contributions may be eligible for government grants.",
    "RESP_FAMILY": "A tax-sheltered account with multiple beneficiaries for post-secondary education savings. Contributions may be eligible for government grants.",
    "RESP_ADULT": "A tax-sheltered savings account for an adult's post-secondary education.",
    "CORPORATE_CASH": "A taxable, general investment account for non-individuals.",
    "CORPORATE_TRUST": "Corporate Trusts",
    "CORPORATE_ESTATE": "Corporate Estate",
    "CORPORATE_CHARITY": "Corporate Charity",
    "RRSP_SPOUSAL": "A tax-sheltered account that allows for tax-deductible contributions from a spouse or common-law partner. Contribution limits apply, and withdrawals may be taxed.",
    "LIRA": "A tax-sheltered account that holds transferred funds from an employer pension plan. Additional contributions are not permitted and assets are locked-in until retirement.",
    "RRIF": "A tax-sheltered retirement income account that is converted from a RRSP. Additional contributions are not permitted and annual minimum withdrawal amounts apply.",
    "LRSP": "A tax-sheltered account that holds transferred funds from an employer pension plan. Additional contributions are not permitted and assets are locked-in until retirement.",
    "RIF_SPOUSAL": "A tax-sheltered retirement income account that is converted from a Spousal RRSP. Additional contributions are not permitted and annual minimum withdrawal amounts apply.",
    "RLSP": "A tax-sheltered account that holds transferred funds from an employer pension plan. Additional contributions are not permitted and assets are locked-in until retirement.",
    "SPOUSAL_RRIF": "A tax-sheltered retirement income account that is converted from a Spousal RRSP. Additional contributions are not permitted and annual minimum withdrawal amounts apply.",
    "LIF": "A tax-sheltered retirement income account that is converted from a locked-in pension plan. Additional contributions are not permitted and annual minimum and maximum withdrawal amounts apply.",
    "PRIF": "A tax-sheltered retirement income account that is converted from a locked-in pension plan. Additional contributions are not permitted and annual minimum withdrawal amounts apply. (SK and MB only)",
    "GRSP": "GRSP",
    "LRIF": "A tax-sheltered retirement income account that is converted from a locked-in pension plan. Additional contributions are not permitted and annual minimum and maximum withdrawal amounts apply. Not permitted in Saskatchewan.",
    "CASH_JOINT": "A taxable, general investment account shared between multiple individuals.",
    "RDSP": "The Registered Disability Savings Plan (RDSP) is a long-term savings plan to help people with disabilities who are approved for the Disability Tax Credit save for the future. When you open a plan, you may also get grants and bonds from the Government of Canada to help with your long-term savings.",
    "RDSP_JOINT": "Secure the financial future of a loved one with a disability by contributing together, accessing potential government grants and bonds, and planning for their long-term needs.",
    "RLIF": "A tax-sheltered retirement income account that is converted from a locked-in pension plan. Additional contributions are not permitted and annual minimum and maximum withdrawal amounts apply.",
    "RESP_SINGLE_JOINT": "A tax-sheltered account for a single beneficiary, with a joint co-owner, for post-secondary education savings. Contributions may be eligible for government grants.",
    "RESP_FAMILY_JOINT": "A tax-sheltered account, with a joint co-owner and for multiple beneficiaries, for post-secondary education savings. Contributions may be eligible for government grants.",
    "INFORMAL_TRUST": "An account used to set aside money for someone else, often a minor child. The trust relationship is informal and lacks formal documentation.",
    "INFORMAL_TRUST_JOINT": "An account used to set aside money for someone else, often a minor child. The trust relationship is informal and lacks formal documentation. Joint account with multiple co-owners.",
    "MARGIN": "Trade stocks, ETFs, and other securities using funds on margin, allowing for increased purchasing power while managing risks and interest costs.",
    "MARGIN_JOINT": "Trade stocks, ETFs, and other securities using funds on margin, allowing for increased purchasing power while managing risks and interest costs.",
    "USA_BROKERAGE": "Trade stocks, funds, ETFs, and more. Invest for long-term goals like retirement, college, or major purchases.",
    "USA_IRA": "Tax-advantaged savings. Deductible contributions. Tax-deferred growth. Trade stocks, funds, ETFs for retirement planning.",
    "USA_RO_IRA": "Combine former Employer-Sponsored Accounts. Tax-advantaged savings. Deductible contributions. Tax-deferred growth. Trade stocks, funds, ETFs for retirement planning.",
    "USA_RT_IRA": "Tax-free retirement savings. Post-tax contributions. No tax on qualified withdrawals. Trade stocks, funds, ETFs, and more for future growth.",
    "USA_INH_IRA": "Inherited IRA account, Mandatory draw down. Trade stocks, funds, ETFs, and more. Maximize tax benefits for inherited assets.",
    "USA_INH_RT_IRA": "Tax-advantaged with no early withdrawal penalty. Trade stocks, funds, ETFs, and more. Maximize tax benefits for inherited assets.",
    "USA_JT_WROS": "Invest together. Shared access to stocks, funds, ETFs, and more for common financial goals.",
    "USA_JT_TIC": "Invest together. Shared access to stocks, funds, ETFs, and more for common financial goals.",
    "USA_JT_JTBE": "Invest together. Shared access to stocks, funds, ETFs, and more for common financial goals.",
    "USA_JT_CP": "Invest together. Shared access to stocks, funds, ETFs, and more for common financial goals.",
    "USA_SEP_IRA": "Simplified retirement plan for self-employed. Tax-deductible contributions. Tax-deferred growth. Invest in stocks, funds, ETFs, and more.",
    "USA_401K": "Employer-sponsored retirement plan. Pre-tax contributions, potential employer match. Diversify with stocks, funds, ETFs for future financial security.",
    "USA_SOLO_401K": "Solo 401(k): Self-employed retirement plan. Maximize contributions as both employer and employee. Invest in stocks, funds, ETFs for financial independence.",
    "USA_TRUST": "Taxable investment management for beneficiaries. Diverse portfolio options. Ensure long-term financial goals with prudent trust management.",
    "USA_CORPORATE": "Tailored investment solutions for businesses. Diversify holdings. Optimize financial strategies for corporate growth and stability.",
    "USA_ESA": "Flexible education fund for all levels. Contribute post-tax dollars. Enjoy tax benefits for diverse educational expenses.",
    "USA_529": "College-centric savings tool. Contribute post-tax dollars. Grow funds tax-advantaged for higher education costs.",
    "USA_TOD": "Transfer assets directly to beneficiaries upon death. No probate required. Retain full control while alive. Simplifies inheritance process.",
    "USA_ESTATE": "An estate account is a temporary account that holds a decedent's assets, like cash, investments, and property, until they are distributed to heirs or beneficiaries. Similar to a brokerage account, it allows the executor to manage and settle the estate's financial matters during the probate process.",
    "USA_DAF": "Donate to a charitable fund with tax benefits. Recommend grants to charities over time. Flexible giving while assets grow tax-free.",
    "USA_SIMPLE_IRA": "Tax-advantaged retirement savings for small businesses. Employer and employee contributions. Simple setup with lower contribution limits than 401(k).",
    "USA_KEOGH": "Tax-advantaged retirement plan for self-employed individuals and small businesses. Higher contribution limits. Offers both defined-benefit and defined-contribution options.",
    "USA_CUSTODIAL": "Managed by an adult for a minor, allowing assets to be held and invested until the minor reaches adulthood.",
    "USA_IRA_CUSTODIAL": "A Custodial IRA is an account a parent manages for a minor with earned income. The custodian controls the assets until the child turns 18 (or 25 in some states), but the funds belong to the child, helping them save early.",
    "USA_DBP": "Employer-sponsored retirement plan offering a guaranteed payout in retirement, based on salary and years of service.",
    "USA_CRA": "Account that hold assets of a plan established elsewhere.",
    "UK_BROKERAGE": "Trade stocks, funds, ETFs, and more. Invest for long-term goals like retirement, college, or major purchases.",
    "UK_CASH_ISA": "Tax-efficient savings account in the UK. Earn interest on cash deposits without paying income tax. Offers flexibility and accessibility for short-term savings goals. Annual contribution limits apply.",
    "UK_SS_ISA": "Tax-efficient investment account in the UK. Enables investing in stocks, shares, bonds, and funds. Income and gains within the account are tax-free. Annual contribution limits apply.",
    "UK_JISA": "Tax-efficient savings account in the UK for children. Parents or guardians can open and manage on behalf of the child. Contributions grow tax-free. Funds can be accessed by the child once they turn 18. Annual contribution limits apply.",
    "UK_PERSONAL_PENSION": "Tax-efficient retirement savings account in the UK. Allows individuals to contribute funds for retirement planning. Contributions are typically eligible for tax relief. Investments grow tax-free until retirement. Various investment options available. Access to funds typically starts at age 55."
  },
  "otherAccountTypes": "Other account types",
  "searchAccounts": "Search account types",
  "noAccountOptions": "We couldn’t find any account types that match. Please refine your search and try again.",
  "custodianConnectionSelector": "Custodian",
  "baseCurrencySelector": "Base Currency",
  "multiCurrencySelector": {
    "toggleMultiCurrency": "Multi-Currency Account",
    "toggleMultiCurrencyInfoTooltip": "This is a multi currency account that will support the holding of multiple cash currency types. It will not be auto-swept so you need to also provide an FX allocation file and associated FX feeds.",
    "availableCurrenciesHelperText": "Base currency is included"
  },
  "custodianChangeConfirmation": {
    "title": "Review affiliates",
    "body": "Changing custodians may require different affiliate information. Please review all account affiliates to ensure their details are complete — missing or outdated info could cause delays or require follow-up."
  },
  "jointOwnershipType": "Joint Ownership Type",
  "withRightOfSurvivorship": "With Right of Survivorship",
  "noRightOfSurvivorship": "No Right of Survivorship",
  "table": {
    "accountNumber": "Account Number",
    "userName": "Account Owner",
    "accountType": "Account Type",
    "organization": "Organization"
  },
  "respAllBeneficiariesAreInBc": "There is only one beneficiary named to this RESP OR all beneficiaries are siblings AND all beneficiaries listed are residents of British Columbia.",
  "baseCurrency": "Base Currency",
  "isMultiCurrencyAccount": "Multi-Currency"
}
